import {
  STAND_WORKSHEET_HEADER_INFO_MESSAGE_OF_OFF_POST_CLOSURE_V1,
  STAND_WORKSHEET_HEADER_INFO_MESSAGE_OF_OFF_POST_CLOSURE_V2,
} from '../stand-worksheet-info-message';

export enum CALCULATION_VERSIONS {
  V1 = '1.0',
  V2 = '2.0',
}

export const OVERRIDE_POST_CLOSURE_VERSIONS: {
  [key in CALCULATION_VERSIONS]: object;
} = {
  '1.0': STAND_WORKSHEET_HEADER_INFO_MESSAGE_OF_OFF_POST_CLOSURE_V1,
  '2.0': STAND_WORKSHEET_HEADER_INFO_MESSAGE_OF_OFF_POST_CLOSURE_V2,
};
